export default "__VITE_ASSET__DPTYYQQs__"